import * as React from "react";
import { connect } from "react-redux";
import { injectIntl, WrappedComponentProps } from "react-intl";
// interfaces

// helpers
import * as EnvChecker from "@vingle/wtf-sdk/helpers/envChecker";

import {
  POSTSHOW_IMPORTANT_SECTION_NAME,
  POSTSHOW_IMPORTANT_ID,
  AD_BLOCKED_POST_IDS,
} from "@vingle/wtf-sdk/constants/neowiz";
import { IAppState } from "app/rootReducer";
// styles
const styles = require("./neowizImportantComponent.scss");

declare var googletag: any;

export enum NEOWIZ_AD_PAGES {
  POST_SHOW,
  COLLECTION_SHOW,
  DISCOVER,
}

function mapStateToProps(state: IAppState) {
  return {
    currentUser: state.app.currentUser,
  };
}

interface IProps
  extends ReturnType<typeof mapStateToProps>,
    WrappedComponentProps {
  page: NEOWIZ_AD_PAGES;
  postId?: Vingle.Id;
  wrapperClassName?: string;
}

function initializeNeowizImportant() {
  if (EnvChecker.isBrowser()) {
    const googleTagApplyNode = document.createElement("script");
    const loadScript = document.createTextNode(
      `var googletag = googletag || {}; googletag.cmd = googletag.cmd || [];`,
    );
    googleTagApplyNode.appendChild(loadScript);
    document.body.appendChild(googleTagApplyNode);

    const googleTagLoadjsNode = document.createElement("script");
    googleTagLoadjsNode.src = "https://www.googletagservices.com/tag/js/gpt.js";
    googleTagLoadjsNode.async = true;
    document.body.appendChild(googleTagLoadjsNode);

    if ((window as any).googletag) {
      googletag.cmd.push(() => {
        const slot = googletag.defineSlot(
          `/9470/${POSTSHOW_IMPORTANT_SECTION_NAME}`,
          [728, 90],
          POSTSHOW_IMPORTANT_ID,
        );
        if (slot) {
          slot.addService(googletag.pubads());
        }
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      googletag.cmd.push(() => {
        googletag.display(POSTSHOW_IMPORTANT_ID);
      });
    }
  }
}

class NeowizImportant extends React.PureComponent<IProps> {
  public componentDidMount() {
    const { currentUser, intl } = this.props;
    if (
      ((currentUser && currentUser.first_language === "ko") ||
        (!currentUser && (intl as any).locale === "ko")) &&
      !this.confirmBlockedPost()
    ) {
      initializeNeowizImportant();
    }
  }

  public render() {
    const { currentUser, intl, wrapperClassName } = this.props;
    let neowizTargetNode: React.ReactNode | null = null;

    if (
      ((intl as any).locale === "ko" ||
        (currentUser && currentUser.first_language === "ko")) &&
      !this.confirmBlockedPost()
    ) {
      neowizTargetNode = (
        <div
          className={`${styles.neowizImportantWrapper} ${wrapperClassName}`}
          id={POSTSHOW_IMPORTANT_ID}
        />
      );
    }

    return <div>{neowizTargetNode}</div>;
  }

  private readonly confirmBlockedPost = () => {
    if (this.props.page === NEOWIZ_AD_PAGES.POST_SHOW && this.props.postId) {
      return AD_BLOCKED_POST_IDS.includes(this.props.postId);
    }
    return false;
  };
}
export default connect(mapStateToProps)(injectIntl(NeowizImportant));
